import React, { useState, useEffect, useContext } from "react";
import { adminGet } from '../adminFetch';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import "./AdminCategoryList.css";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchCategories = async () => {
  const response = await adminGet(`${API_BASE_URL}/api/categories`);
  return response.json();
};

const AdminCategoryList = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [activeTab, setActiveTab] = useState('categories');
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {

    const loadCategories = async () => {
      setIsLoading(true);
      try {
        const data = await fetchCategories();
        const categoryMap = buildCategoryHierarchy(data);
        setCategories(categoryMap);
      } catch (err) {
        setError("Failed to load categories");
      } finally {
        setIsLoading(false);
      }
    };

    loadCategories();
  }, [navigate]);

  // Function to build a nested structure from flat categories
  const buildCategoryHierarchy = (categories) => {
    const categoryMap = {};

    // Initialize categories in a map
    categories.forEach((cat) => {
      categoryMap[cat.categoryID] = { ...cat, subCategories: [] };
    });

    // Assign subcategories to their respective parents
    const rootCategories = [];
    categories.forEach((cat) => {
      if (cat.parentCategoryId) {
        categoryMap[cat.parentCategoryId]?.subCategories.push(categoryMap[cat.categoryID]);
      } else {
        rootCategories.push(categoryMap[cat.categoryID]); // Top-level categories
      }
    });

    return rootCategories;
  };

  // Recursive component to display categories & subcategories
  const renderCategories = (categories, level = 0) => {
    return (
      <ul className={level === 0 ? "admin-category-list" : "admin-category-list-subcategories"}>
        {categories.map((category) => (
          <li key={category.categoryID} className="admin-category-list-item">
            <div className="admin-category-list-item-content">
              <div>
                <div className="admin-category-list-item-name">
                  {level > 0 && <i className="fas fa-level-down-alt" style={{ transform: 'rotate(-90deg)', marginRight: '10px', fontSize: '14px', color: '#3498db' }}></i>}
                  {category.name}
                  <span className={`admin-list-status ${category.isActive === false ? "inactive" : "active"}`}>
                    {category.isActive === false ? "Inactive" : "Active"}
                  </span>
                </div>
                {category.description && (
                  <div className="admin-category-list-item-description">{category.description}</div>
                )}
              </div>
              <div className="admin-category-list-item-actions">
                <a
                  href={`/admin/category/edit/${category.categoryID}`}
                  className="admin-category-list-btn-edit"
                >
                  <i className="far fa-edit"></i> Edit
                </a>
                {/* <button
                  className="admin-category-list-btn-delete"
                  onClick={() => handleDeleteCategory(category.categoryID)}
                >
                  <i className="fas fa-trash-alt"></i> Delete
                </button> */}
              </div>
            </div>
            {category.subCategories.length > 0 && renderCategories(category.subCategories, level + 1)}
          </li>
        ))}
      </ul>
    );
  };

  const handleDeleteCategory = (categoryId) => {
    // Confirmation before delete
    if (window.confirm("Are you sure you want to delete this category?")) {
    }
  };

  if (isLoading) {
    return (
      <div className="admin-category-list-container">
        <div className="admin-category-list-loading">
          <div style={{ textAlign: 'center' }}>
            <i className="fas fa-spinner fa-spin" style={{ fontSize: '40px', color: '#3498db', marginBottom: '15px' }}></i>
            <p>Loading categories...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-category-list-container">
        <div className="admin-category-list-error" style={{
          backgroundColor: '#fdecea',
          color: '#d32f2f',
          padding: '15px',
          borderRadius: '4px',
          margin: '15px 0',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          fontSize: '15px'
        }}>
          <i className="fas fa-exclamation-circle"></i> {error}
        </div>
        <button
          className="admin-category-list-back-btn"
          onClick={() => navigate('/admin/dashboard')}
          style={{ marginTop: '15px' }}
        >
          <i className="fas fa-arrow-left"></i> Back to Dashboard
        </button>
      </div>
    );
  }

  return (
    <div className="admin-category-list-container">
      {/* Back to Dashboard Button */}
      <div className="admin-category-list-header">
        <button
          className="admin-category-list-back-btn"
          onClick={() => navigate('/admin/dashboard')}
        >
          <i className="fas fa-arrow-left"></i> Back to Dashboard
        </button>
      </div>

      {/* Title Section */}
      <div className="admin-category-list-title">
        <h1>Category Management</h1>
      </div>

      {/* Tab Navigation */}
      <div className="admin-category-list-tabs">
        <button
          className={`admin-category-list-tab ${activeTab === 'products' ? 'active' : ''}`}
          onClick={() => navigate('/admin/products')}
        >
          Products
        </button>
        <button
          className={`admin-category-list-tab ${activeTab === 'categories' ? 'active' : ''}`}
          onClick={() => setActiveTab('categories')}
        >
          Categories
        </button>
      </div>

      {/* Add Category Button */}
      <div className="admin-category-list-actions">
        <button
          className="admin-category-list-btn-add"
          onClick={() => navigate('/admin/category/add')}
        >
          <i className="fas fa-plus"></i> Add New Category
        </button>
      </div>

      {/* Category List */}
      <div className="admin-category-list-content">
        {categories.length > 0 ? (
          renderCategories(categories)
        ) : (
          <div className="admin-category-list-empty">
            <i className="fas fa-box"></i>
            <p className="primary-message"> No categories found. Click "Add New Category" to create one.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminCategoryList;